module.exports = __webpack_public_path__ + "img/SAAS.c981519b.png";